module.exports = __webpack_public_path__ + "img/emoji_70.9cfd9482.png";